var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 17C19.4055 17 19.2789 15.75 17.5898 15.75C15.8934 15.75 15.7607 17 14.6699 17C13.5881 17 13.4412 15.75 11.75 15.75C10.0765 15.75 9.90555 17 8.83984 17C7.74031 17 7.62102 15.75 5.91992 15.75C4.21887 15.75 4.09754 17 3 17V13.875C3 12.8398 3.83984 12 4.875 12H5.5V6.375H8V12H10.5V6.375H13V12H15.5V6.375H18V12H18.625C19.6602 12 20.5 12.8398 20.5 13.875V17ZM20.5 22H3V18.25C4.69359 18.25 4.82684 17 5.91992 17C7.01176 17 7.14074 18.25 8.83984 18.25C10.5134 18.25 10.6843 17 11.75 17C12.8495 17 12.9688 18.25 14.6699 18.25C16.3636 18.25 16.4968 17 17.5898 17C18.6636 17 18.8106 18.25 20.5 18.25V22ZM6.75 5.75C6.05664 5.75 5.5 5.19336 5.5 4.5C5.5 3.28906 6.75 3.60156 6.75 2C7.21875 2 8 3.15234 8 4.1875C8 5.22266 7.44336 5.75 6.75 5.75ZM11.75 5.75C11.0566 5.75 10.5 5.19336 10.5 4.5C10.5 3.28906 11.75 3.60156 11.75 2C12.2188 2 13 3.15234 13 4.1875C13 5.22266 12.4434 5.75 11.75 5.75ZM16.75 5.75C16.0566 5.75 15.5 5.19336 15.5 4.5C15.5 3.28906 16.75 3.60156 16.75 2C17.2188 2 18 3.15234 18 4.1875C18 5.22266 17.4434 5.75 16.75 5.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCake);
export default __webpack_public_path__ + "static/media/cake.868b317363c72aa1af977863627c2ee4.svg";
export { ForwardRef as ReactComponent };